<template>
  <div class="container"></div>
</template>

<script>
/* tslint:disable */
import { LOGIN } from '@/routerNames';

export default {
  name: 'LoginSocialCallbackPage',
  created() {
    // SNAP-2309: the API has already set the session cookie. LoginForm loads the user from it and
    // finishes the flow. `session=1` tells the guard not to bounce this to HOME first.
    const redirect = this.$route.query.redirectTo || this.$route.query.redirect;
    const query = { session: '1' };
    if (redirect) query.redirect = redirect;

    this.$router.push({ name: LOGIN, query });
  },
};
</script>
